"use strict";
var ng2_menu_directive_1 = require("./ng2-menu.directive");
exports.Ng2MenuDirective = ng2_menu_directive_1.Ng2MenuDirective;
var ng2_menu_module_1 = require("./ng2-menu.module");
exports.Ng2MenuModule = ng2_menu_module_1.Ng2MenuModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-menu/dist/index.js
// module id = 72
// module chunks = 0